
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { convertToHtmlHelper } from '@/heplers';
import DocIcon from '@/components/ui/icons/DocIcon.vue';

enum BadgeType {
  'info',
  'warning',
  'error',
  'deprecated',
  'beta',
  'hidden',
}

interface Badge {
  type: keyof BadgeType;
  kind: string;
  title: string;
  roles?: string[];
  content: string;
}

@Component({
  components: {
    DocIcon,
  },
  filters: {
    toAllowedName: (kind: string) => {
      if (kind === 'deprecated') return 'error';
      if (kind === 'alert') return 'error';
      if (kind === 'beta') return 'info';
      if (kind === 'hidden') return 'warning';
      if (kind === 'warning') return 'warning';
      return kind;
    },
  },
})
export default class StatusBadge extends Vue {
  @Prop(Object) badgeInfo: Badge;

  public convertToHtml = convertToHtmlHelper;
  public toogleRolesMobile = false;

  private get haveRoles() {
    return this.badgeInfo?.roles?.length;
  }
}
